import { Box, Text } from '@bechtel/gds';
import { RequisitionToolCatalog } from '@bechtel/ht-types';
import { FC } from 'react';
import { getFormatedDate } from '~/utilities';

interface PreviousRevisionsProps {
  previousRevisions: RequisitionToolCatalog;
}

export const PreviousRevisions: FC<PreviousRevisionsProps> = ({ previousRevisions }) => {
  return (
    <Box flexDirection={{ sm: 'column' }}>
      <Text size={200} weight={300}>
        {getFormatedDate(previousRevisions.updatedDate)}
      </Text>
      {previousRevisions.updatedByUser && (
        <Box my={{ sm: '200' }}>
          <Text size={300} weight={600}>
            {`${previousRevisions.updatedByUser?.firstName} ${previousRevisions.updatedByUser?.lastName}`}
          </Text>
        </Box>
      )}
      {/* will be implemented once number of previous revisions data is available */}
      {/* <Text size={250} color="blue.500">
        {previousRevisions.requisitionCatalogToolRooms.length} Last Requested
      </Text> */}
    </Box>
  );
};
